/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */
import axios from 'axios';
import { Fetch, ResponseInfo } from './type';
import mock from '../mock';
import { notification } from 'tea-component';
import { transformDesc, transformTitle } from './notification';
import { message } from 'antd';
//导入react-redux
import { clearState } from "@src/store/actions/user";
import store from '@src/store'

// 是否开启mock
const ISMOCK = false;
// mock 情况下接口为一个取配置数据的promise函数
const MOCKFUNC = (url: string) => (params: any, transformResponse?: (resp: ResponseInfo<any>) => void) =>
  new Promise((resolve) => {
    setTimeout(() => {
      transformResponse?.({
        data: mock[url],
        status: 0,
        statusText: '',
        headers: {},
        config: {},
      });
      resolve(mock[url].Response);
    });
  });

const instance: any = axios.create({
  baseURL: '/',
});

// 是否全局提示错误信息
let ISNOTIFICATION = true;
// 检测是否要显示错误信息的方法
const checkShowMsg = (data: any) => {
  // 不同类型的请求,检测的字段不同
  if (data instanceof FormData && data.get('isShowMsg')) {
    ISNOTIFICATION = false;
    data.delete('isShowMsg');
  } 
  // 普通的post请求
  else if (data.isShowMsg) {
    ISNOTIFICATION = false;
    delete data.isShowMsg;
  }
  // get请求
  else if (data.params && data.params.isShowMsg) {
    ISNOTIFICATION = false;
    delete data.params.isShowMsg;
  }
  //get请求，数据在url中
  else if (data.url && data.url.indexOf('isShowMsg') > -1) {
    ISNOTIFICATION = false;
  }
  // 其他情况
  else {
    ISNOTIFICATION = true;
  }
};


//添加Authorization请求头
instance.interceptors.request.use(
  (config: any) => {
    checkShowMsg(config.data || config);
    // 如果有token,则添加请求头
    const token = store.getState().user.userInfo.token || '';
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
);

instance.interceptors.response.use(
  (response: ResponseInfo<any>) => {
    const resp: any = response?.data;

    if (resp?.Error?.Code) {
      notification.error({
        title: transformTitle(response?.config?.params?.cmb),
        description: transformDesc(resp),
        unique: true,
        duration: 3000,
      });
    }
    if (resp) {
      return resp;
    }
  },
  (error:any) => { // 请求错误处理
    // 未授权或token失效
    if(error.response.status === 401){
      //清除用户信息
      store.dispatch(clearState());
      message.error(error.response.data.msg,1);
      //跳转到首页
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
    }
    //普通情况
    if (error.response.data.msg && ISNOTIFICATION) {
      message.error(error.response.data.msg,1.5);
    }
    return Promise.reject(error);
  }
);
// 对错误信息进行默认处理的get请求 封装函数
export const createGetChannel = (url: string): Fetch<any, any> => {
  if (ISMOCK) {
    return MOCKFUNC(url);
  }

  return (params: any, transformResponse?: (resp: ResponseInfo<any>) => void) =>
    instance.get(url, {
      params: { ...params },
      transformResponse,
    });
};

// 对错误信息进行默认处理的post请求 封装函数
export const createPostChannel = (url: string): Fetch<any, any> => {
  if (ISMOCK) {
    return MOCKFUNC(url);
  }
  return (data: any) =>
    instance.post(
        url,
        data
    );
};

// 下载文件的get请求 封装函数
export const createGetDownloadChannel = (url: string): Fetch<any, any> => {
  if (ISMOCK) {
    return MOCKFUNC(url);
  }
  return (params: any, transformResponse?: (resp: ResponseInfo<any>) => void) =>
    instance.get(url, {
      params: { ...params },
      transformResponse,
      responseType: 'blob',
    });
};



// 单纯处理的post请求 的封装函数
export const createPostFetch = (url: string): Fetch<any, any> => {
  if (ISMOCK) {
    return MOCKFUNC(url);
  }
  return (data: any) =>
    axios.post(
      url,
      {
        ...data,
      },
    );
};


